<table class="table">
  <ng-container *ngIf="isColaborator || subsidiary; else storeView">
    <thead>
      <th>Sku</th>
      <th>Nombre</th>
      <th>Categoria</th>
      <th>Precio</th>
      <th>Presentacion</th>
      <th>Disponible</th>
      <th>Stock</th>
  </thead>
  <tbody>
    <tr *ngFor="let item of products" [ngClass]="{'deleted':item.deleted}">
        <td>{{item.sku}}</td>
        <td><img class="logo" *ngIf="item.imageUrl" [src]="item.imageUrl">
            {{item.label}}</td>
        <td>{{item.categories.length>0? item.categories[item.categories.length-1].label:''}}</td>
          <td>{{item.config.length>0? 'S/ '+item.config[0].price:''}}</td>
          <td index="0" class="selUnit" (click)="listConfig($event)">
              <span>{{item.config.length>0? item.measurementUnitLabelA:''}}</span>
              <i class="fa fa-chevron-down" *ngIf="item.config.length>1"></i>
              <div class="boxConf d-none selUnit" *ngIf="item.config.length>1">
                  <p class="selUnit" *ngFor="let conf of item.config; let i = index"
                      (click)="selectConf($event, conf)">{{conf.measurementUnitLabelA}}</p>
              </div>
          </td>
          <td>{{item.config.length>0? item.config[0].unitAvailable:''}}</td>
          <td>
              <div class="switch" [ngClass]="{'on':item.config.length>0? item.config[0].isInStock:false}">
                  <div class="circle"></div>
              </div>
          </td>
        <td>
            <div class="options opt" *ngIf="!item.deleted">
                <img #imageElement src="assets/images/ico-options.svg" (click)="toggleOptions(imageElement)" class="opt">
                <div class="box d-none opt">
                    <p class="opt" (click)="editar(item)">Editar producto</p>
                    <p *ngIf="isManager" class="opt" (click)="eliminar(item)">Eliminar producto</p>
                </div>
            </div>
        </td>
    </tr>
</tbody>

  </ng-container>

  <ng-template #storeView>
      <thead>
        <th>Sku</th>
        <th>Nombre</th>
        <th>Categoria</th>
    </thead>
    <tbody>
      <tr *ngFor="let item of products" [ngClass]="{'deleted':item.deleted}">
          <td>{{item.sku}}</td>
          <td><img class="logo" *ngIf="item.imageUrl" [src]="item.imageUrl">
              {{item.label}}</td>
          <td>{{item.categories.length>0? item.categories[item.categories.length-1].label:''}}</td>
          <td>
              <div class="options opt" *ngIf="!item.deleted">
                <img #imageElement src="assets/images/ico-options.svg" (click)="toggleOptions(imageElement)" class="opt">
                  <div class="box d-none opt">
                      <p class="opt" (click)="editar(item)">Editar producto</p>
                      <p *ngIf="isManager" class="opt" (click)="eliminar(item)">Eliminar producto</p>
                  </div>
              </div>
          </td>
      </tr>
  </tbody>

  </ng-template>
</table>
